"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = startSpeakActivityOnPostActivitySaga;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _postActivity = require("../actions/postActivity");

var _startSpeakingActivity = _interopRequireDefault(require("../actions/startSpeakingActivity"));

var _whileConnected = _interopRequireDefault(require("./effects/whileConnected"));

var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(startSpeakActivityOnPostActivity),
    _marked2 = /*#__PURE__*/_regeneratorRuntime2.mark(startSpeakActivityOnPostActivitySaga);

function startSpeakActivityOnPostActivity() {
  return _regenerator["default"].wrap(function startSpeakActivityOnPostActivity$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(function (_ref) {
            var meta = _ref.meta,
                payload = _ref.payload,
                type = _ref.type;
            return type === _postActivity.POST_ACTIVITY_PENDING && meta.method === 'speech' && payload.activity.type === 'message';
          }, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return (0, _effects.put)((0, _startSpeakingActivity["default"])());

                  case 2:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked);
}

function startSpeakActivityOnPostActivitySaga() {
  return _regenerator["default"].wrap(function startSpeakActivityOnPostActivitySaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _whileConnected["default"])(startSpeakActivityOnPostActivity);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked2);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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